import { jsx as e } from "react/jsx-runtime";
function r(t) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 50 50", width: "1em", ...t, children: /* @__PURE__ */ e(
    "path",
    {
      d: "M9.03704427,41 C4.59830405,41 1,37.401696 1,32.962963 C1,28.52423 4.59830405,24.9259259 9.03703704,24.9259259 C9.6285985,16.3643991 16.3633663,10 25.1111111,10 C31.3279123,10 36.9104311,14.2050582 39.0790707,20.377149 C39.394503,20.3481529 39.7140394,20.3333333 40.037037,20.3333333 C45.7439795,20.3333333 50.3703704,24.9597243 50.3703704,30.6666667 C50.3703704,35.9855246 46.351795,40.3657939 41.1851852,40.9369336 L9.03704427,41 Z",
      fill: "#eeeff4",
      fillRule: "evenodd"
    }
  ) });
}
export {
  r as default
};
